export default __webpack_public_path__ + "static/GraphikLCWeb-Regular-dbb66857b4834b8c8a610b71a6c2e570.woff";